// icon material-icons库 下面的是对应material-icons官网的对应的文档
let icons = [
  'shouquanguanli-01',
  'circle-XS',
  'shouye',
  'lianjie',
  'celveguanli-01',
  'xiala',
  'tuichudenglu',
  'jiahao',
  'biaoqian',
  'jia',
  'guanbi',
  'yuyintiao',
  'gongzhonghaoguanli',
  'xitongguanli',
  'weixinguanli',
  'riqi',
  'shipin',
  'shipin1',
  'yuyin',
  'tongbu',
  'xitongrizhi',
  'xiugai',
  'tixing',
  'dingyueshouyi',
  'zidongxufei',
  'guanlizijin',
  'zaixian',
  'lixian',
  'qiyong',
  'jianting',
]
export default icons;
